<template>
  <div class="banner__layout">
    <div class="banner__banner banner_serafim">
      <div class="banner__left">
        <h1>День Серафима Саровского</h1>
        <p>
          День стяжания радости и мира! Благотворительный фонд
          <strong>«Серафим»</strong> чествует святого 1 августа ярким марафоном
          «Серафимов день — день чудес и радости».
        </p>
        <p>
          Марафон «Серафимов день» благотворительного фонда
          <strong>«Серафим»</strong> представит девять сильных спикеров,
          экспертов в области медицины, реабилитации, воспитания детей,
          здорового питания, особыми гостями марафона станут святые отцы,
          служители церкви, внёсшие неоценимый вклад в спасение душ и
          становление жизней людей с непростыми жизненными ситуациями.
        </p>
        <p>
          В течение всего дня на страницах Фонда
          <strong>«Серафим»</strong> в социальных сетях <i>Facebook</i>,
          <i>Instagram</i> и <i>ВКонтакте</i> вы сможете прослушать лекции и
          мастер-классы от лучших в своей области специалистов. Эксперты
          расскажут реальные истории исцеления, поделятся полезными лайфхаками и
          практическими наработками, которые можно применить в своей жизни уже
          сейчас все, кто стремится сделать свою жизнь радостной, здоровой и
          успешной не взирая на трудности. Каждый спикер коротко расскажет о
          своём вкладе в становление дела Фонда <strong>«Серафим»</strong> и о
          своей личной истории знакомства с создательницей Фонда
          <strong>Лией Сергеевой</strong>, многодетной мамой и мамой особенного
          ребёнка по имени Серафим, русской девушкой, рискнувшей в 2017 году
          начать строительство бесплатного реабилитационного центра для особых
          детей на уникальных магнитных песках в Уреки (Грузия).
        </p>
      </div>
      <div class="banner__right">
        <div class="banner__image">
          <img src="@/assets/images/QDLOp3qTiVzuezlhsT44y.svg" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SerafimBanner",
  data: () => ({
    loading: true
  })
};
</script>

<style lang="scss">
@import "@/assets/_vars";

.banner {
  .banner_serafim {
    .banner {
      &__left {
        p {
          text-indent: 40px;
        }

        p + p {
          margin: 10px 0 0;
        }
      }

      &__slider {
        position: relative;
      }
    }
  }
}
</style>
